import { Button, defineStyle, useDisclosure } from '@chakra-ui/react';
import { useAccount } from 'wagmi';
import { WalletActionsModal } from '../WalletActionsModal/WalletActionsModal';
import { transformAddress } from '../../utils/transformAddress';
import { useAlert } from '../../hooks/useAlert';
import { ConnectWalletContext } from '../../context/ConnectWalletContext';
import React, { useContext } from 'react';
import { getAccount } from '@wagmi/core';
import { config } from '../../config';

const connectWalletButtonStyles = defineStyle({
  variant: 'outline',
  borderRadius: '12px',
  border: '2px solid',
  borderColor: 'borderGrey.100',
  fontSize: { base: '12px', sm: '15px' },
  lineHeight: '22.5px',
  fontWeight: 500,
  _hover: { borderColor: 'green.100' },
});

export const ConnectWalletButton = React.memo(() => {
  const { address, isConnected } = useAccount();
  const { onOpen, isOpen, onClose } = useDisclosure();

  const { connectWalletCallback, disconnectWalletCallback, setTokenAddress } = useContext(ConnectWalletContext);

  const accountAddress = address ? transformAddress(address) : '';

  const handleAlert = useAlert();

  const handleDisconnect = async () => {
    try {
      await disconnectWalletCallback();
      localStorage.removeItem('tokenAddress');
      setTokenAddress('');
      const address = getAccount(config).address;
      if (address) handleAlert('success', `Disconnect Wallet: ${transformAddress(address)}`);
      onClose();
    } catch (error) {
      console.log(error);
      handleAlert('error', 'Failed to disconnect Wallet');
    }
  };

  const handleConnect = async () => {
    try {
      const tokenAddress = await connectWalletCallback();
      const address = getAccount(config).address;
      if (tokenAddress && address) handleAlert('success', `Connect Wallet: ${transformAddress(address)}`);
    } catch (error) {
      console.log(error);
      handleAlert('error', 'Failed to connect Wallet');
    }
  };

  return !isConnected ? (
    <Button {...connectWalletButtonStyles} onClick={handleConnect}>
      Connect Wallet
    </Button>
  ) : (
    <>
      <Button {...connectWalletButtonStyles} onClick={onOpen}>
        {accountAddress}
      </Button>
      <WalletActionsModal disconnect={handleDisconnect} isOpen={isOpen} onClose={onClose} />
    </>
  );
});
